// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./blocks/post/style.scss
// module id = 5
// module chunks = 1